<template>
  <div class="order-list-container">
    <v-centerForm>
      <template slot='left'>
        <el-form inline :model="searchForm" ref="searchForm" label-width="80px">
          <el-form-item label="订单号" prop="orderNo">
            <el-input placeholder="请输入订单号" v-model="searchForm.orderNo" clearable></el-input>
          </el-form-item>
          <el-form-item label="PNR" prop="pnr">
            <el-input placeholder="请输入PNR" v-model="searchForm.pnr" clearable></el-input>
          </el-form-item>
          <el-form-item label="票号" prop="ticketNo">
            <el-input placeholder="请输入票号" v-model="searchForm.ticketNo" clearable></el-input>
          </el-form-item>
          <el-form-item label="出发地" prop="depCity">
            <el-input placeholder="请输入出发地" v-model="searchForm.depCity" clearable></el-input>
          </el-form-item>
          <el-form-item label="目的地" prop="arrCity">
            <el-input placeholder="请输入目的地" v-model="searchForm.arrCity" clearable></el-input>
          </el-form-item>
          <el-form-item label="去程起飞日期">
            <el-date-picker
              v-model="searchForm.outboundDepDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="乘客姓名" prop="passengerName">
            <el-input placeholder="请输入乘客姓名" v-model="searchForm.passengerName" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
            <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
          </el-form-item>
        </el-form>
      </template>
    </v-centerForm>

    <el-tabs v-model="activeTab" @tab-click="handleTabClick" class="order-tabs">
      <el-tab-pane label="全部订单" name="all"></el-tab-pane>
      <el-tab-pane label="未出票订单" name="unticketed"></el-tab-pane>
      <el-tab-pane label="已出票订单" name="ticketed"></el-tab-pane>
      <el-tab-pane label="问题订单" name="problem"></el-tab-pane>
      <el-tab-pane label="取消订单" name="cancelled"></el-tab-pane>
    </el-tabs>

    <v-tableEncapsulation
      :loading="loadingBtn.tableLoading"
      :columnData="columnData"
      :tableSize="pagination.size"
      :tableData="tableData"
      :tableTotal="pagination.total"
      :currentPage="pagination.current"
      @currentPage="handleCurrentChange"
      @sizeChange="handleSizeChange">
      <el-table-column slot="tripType" label="行程类型" align="center" width="100px">
        <template slot-scope="scope">
          {{ getTripTypeText(scope.row.tripType) }}
        </template>
      </el-table-column>
      <el-table-column slot="orderStatus" label="系统订单状态" align="center" width="150px">
        <template slot-scope="scope">
          <el-tag :type="getStatusTagType(scope.row.orderStatus)" effect="dark">
            {{ getStatusText(scope.row.orderStatus) }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column slot="operate" label="操作" align="center" width="200px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="viewDetail(scope.row)">详单</el-button>
          <el-button
            v-if="hasPermission('order:updateStatus')"
            type="text"
            size="small"
            @click="updateStatus(scope.row)">
            修改订单状态
          </el-button>
        </template>
      </el-table-column>
    </v-tableEncapsulation>
  </div>
</template>

<script>
import { queryOrderList } from '@/api/order/orderApi'
import router from '@/router'

export default {
  name: 'orderList',

  data () {
    return {
      activeTab: 'all',
      searchForm: {
        orderNo: null,
        externalOrderNo: null,
        pnr: null,
        ticketNo: null,
        depCity: null,
        arrCity: null,
        outboundAirline: null,
        returnAirline: null,
        outboundDepDateRange: null,
        returnDepDateRange: null,
        passengerName: null,
        pcc: null,
        ticketChannel: null,
        minProfit: null,
        maxProfit: null
      },
      loadingBtn: {
        tableLoading: false
      },
      columnData: [
        {
          type: 'index',
          label: '序号',
          width: '60px'
        },
        {
          label: 'ID',
          prop: 'id',
          show: false
        },
        {
          label: '系统订单日期',
          prop: 'createTime',
          width: '160px'
        },
        {
          label: '后台订单号',
          prop: 'orderNo',
          width: '180px'
        },
        {
          label: 'PNR',
          prop: 'pnr',
          width: '100px'
        },
        {
          label: '航点',
          prop: 'route',
          width: '120px'
        },
        {
          label: '起飞时间',
          prop: 'outboundDepDate',
          width: '120px'
        },
        {
          slot: 'tripType'
        },
        {
          label: '乘机人数',
          prop: 'passengerCount',
          width: '100px'
        },
        {
          label: '票价',
          prop: 'ticketPrice',
          width: '100px'
        },
        {
          label: '订单总金额',
          prop: 'orderAmount',
          width: '120px'
        },
        {
          label: '出票时间',
          prop: 'ticketTime',
          width: '160px'
        },
        {
          slot: 'orderStatus'
        },
        {
          slot: 'operate'
        }
      ],
      tableData: [],
      pagination: {
        current: 1,
        size: 10,
        total: 0
      }
    }
  },

  methods: {
    // 标签页切换
    handleTabClick (tab) {
      this.activeTab = tab.name
      this.pagination.current = 1
      this.getTableData()
    },

    // 搜索
    search () {
      // 校验乘客姓名格式
      if (this.searchForm.passengerName) {
        if (!this.searchForm.passengerName.includes('/')) {
          this.$message.warning('乘客姓名格式不正确，应为 name/lastName 格式')
          return
        }
      }
      this.pagination.current = 1
      this.getTableData()
    },

    // 重置搜索
    resetSearch () {
      this.$refs.searchForm.resetFields()
      this.searchForm.outboundDepDateRange = null
      this.searchForm.returnDepDateRange = null
      this.pagination.current = 1
      this.getTableData()
    },

    // 刷新
    refresh () {
      this.getTableData()
    },

    // 获取表格数据
    getTableData () {
      this.loadingBtn.tableLoading = true
      const params = {
        current: this.pagination.current,
        size: this.pagination.size,
        ...this.searchForm
      }

      // 根据标签页设置状态数组
      const statusMap = {
        all: null,                    // 全部订单不传状态
        unticketed: [0, 1, 2, 6],     // 未出票：待支付/支付中/支付成功/出票中
        ticketed: [7],                // 已出票：出票成功
        problem: [3, 4, 5],           // 问题订单：支付失败/支付超时/支付成功下单失败
        cancelled: [8, 9, 10]         // 取消订单：已取消/取消申请中/未支付已取消
      }
      if (statusMap[this.activeTab]) {
        params.status = statusMap[this.activeTab]
      }

      // 处理日期范围
      if (params.outboundDepDateRange && params.outboundDepDateRange.length === 2) {
        params.outboundDepDateStart = params.outboundDepDateRange[0]
        params.outboundDepDateEnd = params.outboundDepDateRange[1]
      }
      delete params.outboundDepDateRange

      if (params.returnDepDateRange && params.returnDepDateRange.length === 2) {
        params.returnDepDateStart = params.returnDepDateRange[0]
        params.returnDepDateEnd = params.returnDepDateRange[1]
      }
      delete params.returnDepDateRange

      // 移除空值
      Object.keys(params).forEach(key => {
        if (params[key] === null || params[key] === '' || params[key] === undefined) {
          delete params[key]
        }
      })

      queryOrderList(params).then((res) => {
        this.tableData = res.records || []
        this.pagination.total = res.total || 0
        this.loadingBtn.tableLoading = false
      }).catch(() => {
        this.loadingBtn.tableLoading = false
      })
    },

    // 页码变化
    handleCurrentChange (current) {
      this.pagination.current = current
      this.getTableData()
    },

    // 每页条数变化
    handleSizeChange (size) {
      this.pagination.size = size
      this.pagination.current = 1
      this.getTableData()
    },

    // 查看详情
    viewDetail (row) {
      router.push({
        path: '/order/detail',
        query: { id: row.id }
      })
    },

    // 修改订单状态
    updateStatus (row) {
      this.$prompt('请输入新状态', '修改订单状态', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^\d+$/,
        inputErrorMessage: '状态必须为数字'
      }).then(({ value }) => {
        // TODO: 调用更新状态接口
        this.$message.success('状态更新成功')
        this.getTableData()
      }).catch(() => {})
    },

    // 获取行程类型文本
    getTripTypeText (tripType) {
      const typeMap = {
        '1': '单程',
        '2': '往返',
        '3': '多程'
      }
      return typeMap[tripType] || '-'
    },

    // 获取状态文本
    getStatusText (status) {
      const statusMap = {
        '0': '待支付',
        '1': '支付成功，出票中',
        '2': '支付失败',
        '3': '支付成功，出票失败',
        '4': '出票成功',
        '5': '出票失败，待退款',
        '6': '部分退改',
        '7': '已退改',
        '8': '出票失败，已退款',
        '9': '订单已取消',
        '10': '出票失败，退款失败'
      }
      return statusMap[status] || '-'
    },

    // 获取状态标签类型
    getStatusTagType (status) {
      const statusMap = {
        '0': 'success',      // 待支付
        '1': 'success',   // 支付成功，出票中
        '2': 'warning',   // 支付失败
        '3': 'danger',    // 支付成功，出票失败
        '4': 'success',    // 出票成功
        '5': 'danger',    // 出票失败，待退款
        '6': 'success',   // 部分退改
        '7': 'success',   // 已退改
        '8': 'info',      // 出票失败，已退款
        '9': 'info',   // 订单已取消
        '10': 'danger'      // 出票失败，退款失败
      }
      return statusMap[status] || 'info'
    },

    // 权限检查（简化版，实际应从 store 获取）
    hasPermission (permission) {
      // TODO: 实现权限检查逻辑
      return true
    }
  },

  created () {
    this.getTableData()
  }
}
</script>

<style lang="scss" scoped>
.order-list-container {
  padding: 20px;
  box-sizing: border-box;
  min-height: 100%;
  background: #fff;
}

::v-deep .listManager-btnGroup-wrap {
  margin-top: 0;
  margin-bottom: 20px;
  padding-top: 0;
}

.order-tabs {
  margin-bottom: 20px;
  margin-top: 0;

  ::v-deep .el-tabs__header {
    margin: 0 0 15px 0;
  }

  ::v-deep .el-tabs__nav-wrap::after {
    height: 1px;
  }

  ::v-deep .el-tabs__item {
    padding: 0 20px;
    height: 40px;
    line-height: 40px;
  }

  ::v-deep .el-tabs__active-bar {
    height: 2px;
  }
}

::v-deep .v-tableEncapsulation {
  margin-top: 0;
}
</style>
